import 'app/agriculture/components/Subtitle/Subtitle.scss';

interface SubtitleProps {
    children: string;
}

export function Subtitle({ children }: SubtitleProps) {
    return <p className="Subtitle">{children}</p>;
}
